import { ClientConfig } from '@prismicio/client';

import { createClient as prismicCreateClient } from '@preventx/prismic-services';
import { PrismicRepositoryName } from './types/prismic';

export const repositoryName = (process.env.NEXT_PUBLIC_PRISMIC_ENVIRONMENT ??
  '') as PrismicRepositoryName;

const baseRoutes: ClientConfig['routes'] = [
  { type: 'page', path: '/:lang/:uid' },
  { type: 'home', path: '/:lang', uid: 'home' },
];

const supportRoutes: ClientConfig['routes'] = [
  { type: 'support', path: '/:lang/support/:uid' },
  { type: 'support_article', path: '/:lang/support/article/:uid' },
];

const applicationRoutes: ClientConfig['routes'] = [
  { type: 'application', path: '/:lang/application/:uid' },
];

const articleRoutes: ClientConfig['routes'] = [
  { type: 'article', path: '/:lang/article/:uid' },
  { type: 'compliance', path: '/:lang/compliance/:uid' },
];

const clinicRoutes: ClientConfig['routes'] = [
  { type: 'clinic_details', path: '/:lang/clinic/:uid' },
  { type: 'clinics', path: '/:lang/clinics', uid: 'clinics' },
];

export const createClient = () =>
  prismicCreateClient({
    enablePreview: true,
    routes: routingTable(),
    repositoryName: repositoryName,
  });

/** **Important**:  Due to the way Prismic works if a page type has been created but doesn't exist as physical content
 *                  you may see errors at compilation and/or runtime time. To circumnavigate this issue (at least for
 *                  now) we're utilising a routing table per environment to enforce system stability until we can find a
 *                  better way of allowing optional pages without the need for placeholder pages. */
const routingTable = () => {
  if (!repositoryName) {
    return baseRoutes;
  }

  const routes = {
    shluk: [
      ...baseRoutes,
      ...clinicRoutes,
      ...articleRoutes,
      ...supportRoutes,
      ...applicationRoutes,
    ],
    'preventx-corporate': [
      ...baseRoutes,
      ...articleRoutes,
      ...applicationRoutes,
    ],
    'preventx-global': baseRoutes,
    'preventx-global-staging': baseRoutes,
    'how-preventx': [...baseRoutes, ...articleRoutes],
  }[repositoryName];

  return routes ?? baseRoutes;
};
